import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography, TextField } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import { formatDateTime } from '../../../../../../services/functions';

const PLOrderDetailsForm = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);

  console.log('formik', formik);
  console.log(' order', order);

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack justifyContent="space-around" spacing={1} sx={{ width: '50%' }}>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Numer Zamówienia</Typography>
          <SmallFormTextField
            error={formik.errors.identifier && formik.touched.identifier}
            name="identifier"
            placeholder="numer zamówienia"
            value={formik.values.identifier}
            onChange={formik.handleChange}
            helperText={formik.errors.identifier}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Data zamówienia</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              name="created_at"
              ampm={false}
              inputFormat="yyyy-MM-dd HH:mm"
              mask="____-__-__ __:__"
              label="data zamówienia"
              value={formik.values.created_at}
              onChange={val => formik.setFieldValue('created_at', formatDateTime(val))}
              renderInput={params => <TextField size="small" sx={{ width: '60%' }} {...params} />}
            />
          </LocalizationProvider>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Impreza</Typography>
          <SmallFormTextField
            select
            name="event"
            placeholder="impreza"
            options={order.resort_event_camp_data.events}
            value={formik.values.event}
            onChange={e => {
              formik.handleChange(e);
              formik.setFieldValue('camp', '');
            }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Turnus</Typography>
          <SmallFormTextField
            select
            name="camp"
            placeholder="turnus"
            options={order.resort_event_camp_data.camps[formik.values.event]}
            value={formik.values.camp}
            onChange={formik.handleChange}
            error={formik.touched.camp && Boolean(formik.errors.camp)}
            helperText={formik.touched.camp && formik.errors.camp}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2">Wariant</Typography>
          <SmallFormTextField
            select
            name="variant"
            placeholder="wariant"
            options={order.resort_event_camp_data.variants}
            value= {formik.values.variant ? formik.values.variant : order.variant}
            onChange={formik.handleChange}
            error={formik.touched.variant && Boolean(formik.errors.variant)}
            helperText={formik.touched.variant && formik.errors.variant}
          />
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} sx={{ width: '50%' }}>
        <Typography variant="subtitle2">Uwagi</Typography>
        <SmallFormTextField name="comments" placeholder="uwagi" multiline rows={16} value={formik.values.comments} onChange={formik.handleChange} />
      </Stack>
    </Box>
  );
};

export default PLOrderDetailsForm;
